import "lazysizes"
import React from "react"
import { LanguageProvider } from "./src/context/LanguageContext"

export const wrapPageElement = ({ element }) => {
  return <LanguageProvider>{element}</LanguageProvider>
}